import React from "react";
import "./Banner.scss";

interface Props {
    hero: string;
    title?: React.ReactNode | string;
    subtitle?: React.ReactNode | string;
}
const Banner = ({
                    hero,
                    title,
                    subtitle,
                }: Props) => {

    return (
        <section
            className="banner mob-banner d-flex align-items-center position-relative"
            style={{
                backgroundImage: `url(${hero})`,
            }}
        >
            <div className="container mobile-banner-container">
                <div className="row">
                    <div className="col-12 col-md-4">
                        <div className="banner-content-box py-md-0 pe-0 pe-md-5">
                            <h1 className="main-page-title">{title}</h1>
                            <p className="main-page-subtitle">{subtitle}</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
export default Banner;
